import { SubscriptionPlan, ProductsUniqueIds, SiteLinks, UserDetailsFormData } from "../../../../../global/paywall/paywallInterfaces";
import { HyperLinkBuilder } from "../../../../commonComponents/inline/hyperLink";
import { SettingLinks } from "../premiumPaywallCheckout";

interface PaywallCheckoutMobileFinishProps {
    setShouldRedirect: (shouldRedirect: boolean) => void;
    selectedPlan: SubscriptionPlan | null;
    userFormData: UserDetailsFormData
    settingLinks: SettingLinks;
}

const PaywallCheckoutMobileFinish = (props: PaywallCheckoutMobileFinishProps) => {
    const { setShouldRedirect, selectedPlan, userFormData, settingLinks } = props;
    const { firstName, lastName, email, phone } = userFormData;
    const { terms, privacy, contact, myAccount } = settingLinks;
    const isMonthly = selectedPlan.productUniqueId === ProductsUniqueIds.MONTHLY_PASS;
    const planTitle = isMonthly ? "חבילה בחיוב חודשי מתחדש" : "חבילה בחיוב שנתי מתחדש";
    const planPrice = isMonthly ? "₪29.90 לחודש" : "₪299.90 לשנה";


    return (
        <div className="PaywallCheckoutFinish">
            <div className="success-logo"></div>
            <div className="title"> הרכישה הושלמה! </div>
            <div className="subtitle">
                מעכשיו תוכלו ליהנות מגישה חופשית לכל
                <br />
                תכני ידיעות+  ולמהדורה הדיגיטלית של
                           ידיעות אחרונות
                    </div>

            <div className="checkout-container">
                <div className="plan-info">
                    <div className="plan-title">{planTitle}</div>
                    <div className="plan-price-text">{planPrice}</div>
                </div>
                <div className="customer-info">
                    <div className="customer-title">פרטי המנוי</div>
                    <div className="inner-container">
                        <div className="customer-name">{firstName + " " + lastName}</div>
                        <div className="customer-email">{email}</div>
                        <div className="custome-phone">{phone}</div>
                    </div>
                    <div className="customer-myaccount-info">ניתן לצפות ולערוך את פרטי המנוי <HyperLinkBuilder className="underline" href={myAccount.url} linkTarget={myAccount.target}>באזור האישי</HyperLinkBuilder></div>
                </div>
            </div>

            <button className="continue-button" onClick={() => setShouldRedirect(true)}>מעבר לידיעות+</button>
            {/* <div className="footer">
                <div className="footer-links">
                    <ul>
                        <li><HyperLinkBuilder linkTarget={terms.target} href={contact.url}>צור קשר</HyperLinkBuilder></li>
                        <li>|</li>
                        <li><HyperLinkBuilder linkTarget={privacy.target} href={privacy.url}> מדיניות פרטיות</HyperLinkBuilder></li>
                    </ul>
                </div>
                <div className="footer-terms-text">
                    לביטול מינוי ידיעות+ כדין יש לשלוח שם מלא וטלפון באחד מהאופנים הבאים:  <HyperLinkBuilder linkTarget={contact.target} href={contact.url}>מילוי טופס</HyperLinkBuilder> או בדוא״ל <a href="mailto:support.plus@yedioth.co.il">support.plus@yedioth.co.il</a>  או בת.ד 438 ראשון לציון או בטל׳  3733* / 03-6933933 או בפקס 03-6933999 | ידיעות מינויים ח.פ 540181054
                </div>
            </div> */}

        </div>
    );
};

export default PaywallCheckoutMobileFinish;
